import { bankLogoList } from './constants'

export function getBankIconFromCardNumber(cardNumber: string) {
  const cardNoInputInitials = cardNumber.slice(0, 6)
  return bankLogoList.find((bank) => cardNoInputInitials === bank.cardNo)
}

export function getBankIconFromCardPrefix(cardPrefix: string) {
  return bankLogoList.find((bank) => cardPrefix === bank.cardNo)
}

export function formatCreditCard(value: string, mask: string, separator = '-') {
  const removedNoneNumberChars = value
    ?.replace(/\s+/g, '')
    ?.replace(/[^0-9]/gi, '')
  const parts = []
  let formattedValue = removedNoneNumberChars

  const diff = 16 - formattedValue.length
  if (diff > 0) {
    const dotString = Array(diff).fill(mask).join('')
    formattedValue += dotString
  }

  //split the card number into 4 digits groups
  for (let i = 0, len = formattedValue.length; i < len; i += 4) {
    parts.push(formattedValue.substring(i, i + 4))
  }

  return parts.join(separator)
}

export function persianNumsToEnglish(s: string): string {
  return s?.replace(/[۰-۹]/g, (d) => `${'۰۱۲۳۴۵۶۷۸۹'.indexOf(d)}`)
}
